import { Async as ReactSelect } from 'react-select';
import { deprecated } from '../../constants/texts';

import { filter, map } from 'ramda';
import PropTypes from 'prop-types';

export default class Authority extends React.PureComponent {
  static propTypes = {
    autoFocus: PropTypes.bool,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    multi: PropTypes.bool,
    name: PropTypes.string.isRequired,
    onBlur: PropTypes.func,
    onChange: PropTypes.func.isRequired,
    styles: PropTypes.object,
    type: PropTypes.oneOf(['cm:person', 'cm:authorityContainer']),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]),
  };

  static defaultProps = {
    autoFocus: false,
    className: '',
    disabled: false,
    multi: false,
  };

  constructor(props) {
    super(props);

    this.getOptions = ::this.getOptions;
  }

  componentDidMount() {
    console.warn('ReactSelect -- ', deprecated);
  }

  getOptions(input) {
    const { type } = this.props;

    return fetch(
      `${window.appContext}/proxy/alfresco/api/forms/picker/authority/children?size=20${
        input ? `&searchTerm=${input}` : ''
      }${type ? `&selectableType=${type}` : ''}`,
      {
        credentials: 'same-origin',
      }
    )
      .then(response => response.json())
      .then(response => {
        const filtered = filter(
          item => {
            if (window.Alfresco.constants.USERNAME !== 'onlio-admin') {
              return item.name !== 'onlio_sudo_allowed' && item.name !== 'onlio_sudo_disallowed';
            }

            return true;
          },
          filter(item => {
            return (
              !item.name.startsWith('ALFRESCO') &&
              !item.name.startsWith('SITE') &&
              !item.name.startsWith('EMAIL') &&
              item.selectable
            );
          }, response.data.items)
        );

        return map(
          item => ({
            ...item,
            label: item.name,
            value: item.nodeRef,
          }),
          filtered
        );
      });
  }

  render() {
    const {
      autoFocus,
      className,
      disabled,
      multi,
      name,
      value,
      readOnly,
      title,
      onBlur,
      onChange,
      styles,
    } = this.props;

    return (
      <ReactSelect
        autoFocus={autoFocus}
        className={className}
        classNamePrefix="Edocat-Select"
        defaultOptions
        id={name}
        isDisabled={disabled}
        isMulti={multi}
        loadingMessage={() => window.Alfresco.messages.global['label.loading']}
        loadOptions={this.getOptions}
        name={name}
        noOptionsMessage={() => window.Alfresco.messages.global['edocat.text.no-results']}
        onBlur={onBlur}
        onChange={onChange}
        placeholder={`${window.Alfresco.messages.global['button.select']}...`}
        readOnly={readOnly}
        searchPromptText={window.Alfresco.messages.global['edocat.forms.select.search-prompt-text']}
        title={title}
        value={value}
        styles={{
          ...styles,
          container: base => ({
            ...base,
            zIndex: 5,
          }),
          control: base => ({
            ...base,
            borderColor: '#ccc',
            boxShadow: 'none',
            background: '#fff',
            '&:hover': {
              borderColor: '#ccc',
              boxShadow: 'none',
            },
          }),
        }}
      />
    );
  }
}
